<template>
    <KTLoader v-if="loaderEnabled" :logo="loaderLogo"></KTLoader>
    <!-- begin:: Body -->
    <div class="contact-verify-layout page d-flex flex-row flex-column-fluid bgi-no-repeat " style="background-image: url('/media/illustrations/sketchy-1/14.png')">
        <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
            <div id="kt_header" style="" class="header align-items-stretch bg-white">
                <div :class="{'container-fluid': headerWidthFluid,'container-xxl': !headerWidthFluid }" class="d-flex align-items-stretch justify-content-between">
                    <!--begin::Mobile logo-->
                    <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
                        <a href="#" class="d-lg-none">
                            <img alt="Logo" src="/logo/logo-puan-kocum.svg" class="h-50px"/>
                        </a>
                    </div>
                    <!--end::Mobile logo-->

                    <!--begin::Wrapper-->
                    <div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
                        <div class="d-flex align-items-stretch" id="kt_header_menu_nav"></div>
                        <div class="d-flex align-items-stretch flex-shrink-0">
                            <div class="d-flex align-items-center ms-1 ms-lg-3" id="kt_header_user_menu_toggle">
                                <!--begin::Menu-->
                                <div class="cursor-pointer symbol symbol-30px symbol-md-40px" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end" data-kt-menu-flip="bottom">
                                    <img src="/media/avatars/blank.png" alt="metronic"/>
                                </div>
                                <KTUserMenu></KTUserMenu>
                                <!--end::Menu-->
                            </div>
                        </div>
                    </div>
                    <!--end::Wrapper-->
                </div>
            </div>
            <div id="kt_content" class="content d-flex flex-column flex-column-fluid pb-0 pt-0 mt-n20">
                <div class="d-flex flex-center flex-column flex-column-fluid p-10 pt-0 pb-0 mb-0">
                    <!--begin::Logo-->
                    <a href="#" class="mb-15 d-lg-block d-none">
                        <img alt="Logo" src="/logo/logo-puan-kocum.svg" class="h-75px"/>
                    </a>
                    <!--end::Logo-->

                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import KTLoader from "@/components/Loader.vue";
import KTUserMenu from "@/layouts/header/partials/UserMenu.vue";
import { headerWidthFluid, loaderEnabled,  loaderLogo,} from "@/core/helpers/config";
import {MenuComponent} from "@/assets/js/components/MenuComponent";

export default {
    name: "contact-verify",
    components: {
        KTLoader,
        KTUserMenu
    },
    data(){
        return {
            headerWidthFluid,
            loaderEnabled,
            loaderLogo
        }
    },
    mounted() {
        setTimeout(() => {
            MenuComponent.reinitialization();
        }, 500);
    }
}
</script>

<style>
.header-fixed.toolbar-fixed .contact-verify-layout .wrapper {
    padding-top: 0 !important;
}
.aside-enabled.aside-fixed.header-fixed .contact-verify-layout .header {
    left: 0 !important;
}
.aside-enabled.aside-fixed .contact-verify-layout .wrapper {
    padding-left: 0 !important;
}
</style>